import { ObjectOps, ArrayOps } from '../lift';
/**
 * Creates an Array of all this object's values.
 */
export function values() {
    var obj = this.value(), result = [];
    Object.keys(obj).forEach(function (key) {
        result.push(obj[key]);
    });
    return new ArrayOps(result);
}
ObjectOps.prototype.values = values;
